<script setup lang="ts">
  import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'

  const props = defineProps<{
    id: string
    quote: QuotedPlanVm
    stacked?: boolean
  }>()

  const { getId } = Id.use(props.id)
</script>

<template>
  <article
    class="relative flex h-full w-full flex-col gap-4 rounded-quote border border-border bg-white px-5 py-3 shadow-push-button sm:px-8"
    :id="getId()"
  >
    <header>
      <slot name="header" v-bind="{ getId }"></slot>
    </header>
    <main class="grid place-items-center gap-4">
      <slot name="default" v-bind="{ getId }"></slot>
    </main>
    <footer
      class="relative flex w-full items-center justify-between"
      :class="stacked ? 'flex-col-reverse' : 'flex-col-reverse  md:flex-row'"
    >
      <slot name="footer" v-bind="{ getId }"></slot>
    </footer>
  </article>
</template>

<style scoped></style>
